import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormErrorComponent implements OnChanges {
  errorMessages: string[] = []
  
  @Input() title: string
  @Input() set error(value: any) {
    if(!value)
      this.errorMessages = []

    if(value && value.error.message)
      this.errorMessages = [value.error.message]

    if(Array.isArray(value))
      this.errorMessages = value.filter(err => err && err.error.message)
        .map(err => err.error.message)
  }

  constructor(
    private element: ElementRef,
    private translate: TranslateService
  ) {}

  ngOnChanges() {
    if(this.hasErrors)
      this.scrollToMe()
    
      if(!this.title)
        this.title = this.translate.instant('error.form-error-title')
  }

  get hasErrors(): boolean {
    return !!this.errorMessages.length
  }

  scrollToMe() {
    let top = this.element.nativeElement.scrollTop

    if(window)
      window.scrollTo(0, top)
  }
}
